import catalogueJson from "./catalogue.generated.json";

export type DesignSystemCataloguePreview =
  | { mode: "live"; fixture: string }
  | { mode: "current-surface" }
  | { mode: "linked"; route: string };

export interface DesignSystemCatalogueCategory {
  id: string;
  labelKey: string;
  descriptionKey: string;
}

export interface DesignSystemCatalogueComponent {
  id: string;
  exportName: string;
  register: "framework" | "app" | "shared";
  version: string;
  status: "canonical";
  categoryId: string;
  preview: DesignSystemCataloguePreview;
  purpose: string;
  anatomy: Array<{ part: string; carries?: string }>;
  variants: Array<{ name: string; meaning: string }>;
  states: Record<string, string>;
  keyboardAndAssistiveBehavior: string[];
  failureBehavior: string[];
  /** Public-safe framework reference artefacts generated from the component contract. */
  code: string;
  prompt: string;
  /** Deterministic asset-manifest metadata for the exported reference artefacts. */
  asset: DesignSystemCatalogueAsset;
}

export interface DesignSystemCatalogueAsset {
  assetId: string;
  assetClass: "design-component-reference";
  version: string;
  registryVersion: string;
  generatorVersion: string;
  codeHash: string;
  promptHash: string;
}

export interface DesignSystemCatalogue {
  schemaVersion: string;
  generatorVersion: string;
  componentRegistryVersion: string;
  categories: DesignSystemCatalogueCategory[];
  components: DesignSystemCatalogueComponent[];
}

/** Public-safe local component contracts. Source paths and upstream records are excluded. */
export const designSystemCatalogue = catalogueJson as DesignSystemCatalogue;
